import { Directive, Input, HostListener, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[rmsNgSelectPanelClass]',
  standalone: false
})
export class NgSelectPanelClassDirective {
  @Input('rmsNgSelectPanelClass') panelClass: string | Array<string> = '';
  private addedClasses: Array<string> = new Array<string>();

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  @HostListener('open')
  onOpen() {
    setTimeout(() => {
      const panels = this.document.querySelectorAll('ng-dropdown-panel');
      const dropdownPanel = panels[panels.length - 1];

      if (dropdownPanel) {
        const classes = Array.isArray(this.panelClass)
          ? this.panelClass
          : this.panelClass.split(' ').filter(c => c);

        classes.forEach(className => {
          this.renderer.addClass(dropdownPanel, className);
        });

        this.addedClasses = classes;
      }
    }, 0);
  }

  @HostListener('close')
  onClose() {
    if (this.addedClasses.length > 0) {
      const dropdownPanel = this.document.querySelector('ng-dropdown-panel');
      if (dropdownPanel) {
        this.addedClasses.forEach(className => {
          this.renderer.removeClass(dropdownPanel, className);
        });
        this.addedClasses = [];
      }
    }
  }
}
